import { create } from 'zustand'
import type { ChatOfferCreatedEvent } from '@kc3/contracts'

export type ChatOfferPhase = 'offered' | 'connecting'

interface ChatOfferStoreState {
  pendingOffer: ChatOfferCreatedEvent | null
  phase: ChatOfferPhase
  acceptedConversationId: string | null
  /** Countdown display value, ticked by ChatOfferPopup's own setInterval
   *  (computed from pendingOffer.expiresAt) — null when no offer is active
   *  or the countdown hasn't been computed yet for a freshly-set offer. */
  secondsRemaining: number | null
  setOffer: (event: ChatOfferCreatedEvent) => void
  setConnecting: () => void
  setAccepted: (conversationId: string) => void
  setSecondsRemaining: (seconds: number | null) => void
  clearOffer: () => void
}

export const useChatOfferStore = create<ChatOfferStoreState>()((set) => ({
  pendingOffer: null,
  phase: 'offered',
  acceptedConversationId: null,
  secondsRemaining: null,
  setOffer: (event) =>
    set({ pendingOffer: event, phase: 'offered', acceptedConversationId: null, secondsRemaining: null }),
  setConnecting: () => set({ phase: 'connecting' }),
  setAccepted: (conversationId) => set({ acceptedConversationId: conversationId }),
  setSecondsRemaining: (seconds) => set({ secondsRemaining: seconds }),
  clearOffer: () =>
    set({ pendingOffer: null, phase: 'offered', acceptedConversationId: null, secondsRemaining: null }),
}))
